// --------------------------------------------------------
// ALTA PROFISSIONAL FIELD - AltaProfissionalField
// --------------------------------------------------------

import { Divider, MenuItem, Select, TextField } from '@mui/material';
import React from 'react'
import { H3 } from '../../../../../../../components/UI/generalLayout/Layout.styled'
import AddButtonField from '../AddButtonField'
import { ReactComponent as Trash } from '../../../../../../../assets/imgs/trashBin.svg';
import { removeFieldFromList } from '../../../../../../../helpers/CareLineHelperFunctions';
import useResponsiveInfo from '../../../../../../../hooks/useResponsiveInfo';
import { addValueToObject } from '../../../../../../../helpers/HelperFunctions';
import moment from 'moment';

interface IAltaProfissionalField {
    altas: any[];
    isViewState: boolean;
    setAltas: (value: any) => void;
}

const MotivosAlta = [
    { label: 'Melhorado', value: 'melhorado' },
    { label: 'Falta de adesão', value: 'falta_adesao' },
    { label: 'Seguimento externo', value: 'seguimento_externo' },
    { label: 'Desligamento', value: 'desligamento' },
    { label: 'Óbito', value: 'obito' },
];

const AltaProfissionalField = ({ altas, setAltas, isViewState }: IAltaProfissionalField) => {
    const { isMobile } = useResponsiveInfo();

    return (
        <>
            {altas.map((alta: any, index: number) => {
                return <div key={index}>
                    <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', gap: isMobile ? 0 : 20, marginBottom: 10 }}>
                        <div style={{ flex: 1 }}>
                            <H3>Data e hora:</H3>
                            <TextField
                                value={alta.dataHora ? moment(alta.dataHora).format('DD/MM/YYYY HH:mm') : moment().format('DD/MM/YYYY HH:mm')}
                                disabled={true}
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{ backgroundColor: '#f5f5f5' }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <H3>Motivo da alta:</H3>
                            <Select
                                value={alta.motivo || ''}
                                onChange={(event: any) => { addValueToObject({ motivo: event.target.value }, index, setAltas) }}
                                disabled={isViewState}
                                size="small"
                                fullWidth
                                displayEmpty
                            >
                                <MenuItem value="" disabled>Selecionar motivo</MenuItem>
                                {MotivosAlta.map((m) => (
                                    <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                </div>
            })}
        </>
    )
}

export default AltaProfissionalField
